import React from 'react'
import {Calculator} from 'lucide-react'

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-gray-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 text-white font-bold text-xl mb-4">
              <Calculator className="w-6 h-6" />
              <span>TaxPayCalculator</span>
            </div>
            <p className="text-sm text-gray-400">
              Free payroll calculator and paycheck estimator. Calculate your take home pay after federal tax, state tax, Social Security, and Medicare deductions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="/" className="hover:text-white transition-colors">Payroll Calculator</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Military Calculator</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Hourly Calculator</a></li>
            </ul>
          </div>

          {/* Popular States */}
          <div>
            <h3 className="text-white font-semibold mb-4">Popular States</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-white transition-colors">Georgia Calculator</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Virginia Calculator</a></li>
              <li><a href="#" className="hover:text-white transition-colors">California Calculator</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Washington Calculator</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-sm text-center text-gray-400">
          <p>© {new Date().getFullYear()} TaxPayCalculator.com. All rights reserved. For informational purposes only.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
